// Path: ./src/utils/banner/bannerLinkUrl.ts
import { BannerLinkType } from "@swagger/typescript-fetch-goflyer";

export type BannerLinkError =
  | "pairIncomplete"
  | "internalMustStartWithSlash"
  | "internalResolvesOffSite"
  | "externalMustBeHttps"
  | "unsafeScheme";

export const validateBannerLink = (
  linkType?: BannerLinkType,
  linkUrl?: string,
): BannerLinkError | undefined => {
  const value = linkUrl?.trim();
  const hasType = Boolean(linkType);
  const hasUrl = Boolean(value);

  if (!hasType && !hasUrl) return undefined;
  if (hasType !== hasUrl) return "pairIncomplete";

  const lowered = (value as string).toLowerCase();
  if (lowered.startsWith("javascript:") || lowered.startsWith("data:")) {
    return "unsafeScheme";
  }

  if (String(linkType) === String(BannerLinkType.Internal)) {
    if (!(value as string).startsWith("/")) return "internalMustStartWithSlash";
    if (
      (value as string).startsWith("//") ||
      (value as string).startsWith("/\\")
    ) {
      return "internalResolvesOffSite";
    }
    return undefined;
  }

  if (String(linkType) === String(BannerLinkType.External)) {
    if (!lowered.startsWith("https://")) return "externalMustBeHttps";
    return undefined;
  }

  return undefined;
};

export const ctaNeedsLink = (cta?: string, linkUrl?: string): boolean =>
  Boolean(cta?.trim()) && !linkUrl?.trim();
